module.exports = __webpack_public_path__ + "static/media/home-page.cddc7eae.png";